import React, { useState } from 'react'
import { arrow } from '../../../assets';
import { Corner } from '../../../assets';

const Dropdown = ({corner, optionss, defaultOption}) => {
    const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(`${defaultOption}`);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };
  return (
    <>
         <div className="custom-select w-full  cursor-pointer z-10 bg-gray-inputGray">
      <div className={`font-inter  text-gray-lightGray font-normal select-header shadow-inputShadow w-full max-w-[400px] justify-between box-border p-[20px] items-center  flex h-[60px] ${isOpen ? 'open' : ''} `} onClick={toggleDropdown}>
         {selectedOption }
         <img className={`${corner ? 'absolute top-0 right-0' : 'hidden'}`} src={Corner} alt="corner" />
         <img src={arrow} alt='more' className={`w-[14px] h-[8px]  ${isOpen ? 'origin-center  ease-in duration-300' : 'rotate-180 ease-in duration-150'}`}/>
      </div>
      <div className={`options absolute bg-gray-inputGray w-full max-w-[388px] box-border z-20  ${isOpen ? 'open' : 'hidden'}`}>
        {optionss.map((option) => (
          <div
            key={option}
            className={`text-gray-lightGray font-inter font-normal px-[20px] py-[8px] option border-y-[1px] border-solid border-gray-borderGray  ${option === selectedOption ? 'selected' : ''}`}
            onClick={() => handleOptionClick(option)}
          >
            {option}
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default Dropdown